/**
 * Functions related to mobile menu functionality
 *
 * @return void
 *
 */

import {body, activeClass, addEventListenerIfElExists, addEventListenersIfElExists, mobileMenuOpenClass} from './helpers'

export const mobileMenu = () => {
	const toggleMobileMenuBtn = document.querySelector( '.js-toggle-menu' );
	const toggleMenuItemEls = document.querySelectorAll( '.menu__item.has-children > .menu__link' );
	const closeMobileMenuEls = document.querySelectorAll( '.js-close-menu > .menu__link' );

	function toggleMobileMenu( el ) {
		el.preventDefault();

		this.classList.toggle( activeClass );
		body.classList.toggle( mobileMenuOpenClass );
	}

	function toggleMenuItem(el) {
		el.preventDefault();

		this.parentNode.classList.toggle( activeClass );
	}

	function closeMobileMenu(el) {
		toggleMobileMenuBtn.classList.toggle( activeClass );
		body.classList.toggle( mobileMenuOpenClass );
	}

	addEventListenerIfElExists( toggleMobileMenuBtn, 'click', toggleMobileMenu );
	addEventListenersIfElExists( toggleMenuItemEls, 'click', toggleMenuItem );
	addEventListenersIfElExists( closeMobileMenuEls, 'click', closeMobileMenu );
};

